export default {"src":"/_next/static/media/radiobutton-filled.dd8be864.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};